export default __webpack_public_path__ + "static/media/6.f945ef0e.jpg";